var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeerbitLogoTyped(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 22,
    viewBox: "0 0 159 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H21.6825V3.12089C21.6825 3.46081 21.5493 3.78681 21.3122 4.02717C21.075 4.26753 20.7534 4.40256 20.4181 4.40256H4.33701V8.79231H21.6825V21.9859H1.26443C0.929085 21.9859 0.607471 21.8509 0.370344 21.6105C0.133217 21.3701 0 21.0441 0 20.7042L0 17.5833H17.3468V13.1885H0V0Z",
    fill: "#FF3C38"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0221 4.40256L26.0171 0H47.7009V4.40256H26.0221Z",
    fill: "#FF3C38"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.7261 17.5899V20.7184C47.7261 21.0584 47.5929 21.3844 47.3557 21.6247C47.1186 21.8651 46.797 22.0001 46.4616 22.0001H26.0474L26.0334 8.79883H47.7008V13.195H30.3464V17.5911L47.7261 17.5899Z",
    fill: "#FF3C38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0402 4.40256L52.0352 0H73.7189V4.40256H52.0402Z",
    fill: "#FF3C38"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7444 17.5899V20.7184C73.7444 21.0584 73.6111 21.3844 73.374 21.6247C73.1369 21.8651 72.8153 22.0001 72.4799 22.0001H52.0593L52.0454 8.79883H73.7165V13.195H56.3622V17.5911L73.7444 17.5899Z",
    fill: "#FF3C38"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M125.754 0H104.072V21.9987H123.858C124.361 21.9987 124.843 21.7962 125.199 21.4356C125.554 21.0751 125.754 20.5861 125.754 20.0762V13.1885L123.586 10.9904L125.754 8.79103V0ZM121.417 17.5833H108.408V13.1885H121.417V17.5833ZM121.417 8.79231H108.408V4.39616H121.417V8.79231Z",
    fill: "#FF3C38"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M130.09 0H134.427V21.9859H131.986C131.483 21.9859 131.001 21.7834 130.645 21.4228C130.29 21.0623 130.09 20.5733 130.09 20.0634V0Z",
    fill: "#FF3C38"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M137.317 0H159V4.39615H150.327V21.9859H147.887C147.384 21.9859 146.901 21.7834 146.546 21.4228C146.19 21.0623 145.99 20.5733 145.99 20.0634V4.39615H137.317V0Z",
    fill: "#FF3C38"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.0535 0V4.39615H95.4002V8.79231H78.0535V21.9859H81.126C81.4614 21.9859 81.783 21.8509 82.0201 21.6105C82.2573 21.3701 82.3905 21.0441 82.3905 20.7042V13.1936H86.7262L93.1559 20.6683C93.5119 21.0821 93.9513 21.4138 94.4445 21.6411C94.9376 21.8684 95.473 21.9859 96.0147 21.9859H99.736L92.0811 13.1885H99.736V0H78.0535Z",
    fill: "#FF3C38"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeerbitLogoTyped);
export default __webpack_public_path__ + "static/media/seerbit_logo_typed.bb345fdbf6887c9581f6f710d6d28114.svg";
export { ForwardRef as ReactComponent };